<mat-accordion
  displayMode="default"
  class="w100"
  [multi]="false"
  [hideToggle]="false"
>
  <mat-expansion-panel
    [hideToggle]="false"
    class="w100"
    *ngFor="let re of reports; let i = index"
  >
    <mat-expansion-panel-header
      >{{ re.email }} | {{ re.username }} | Round-ID:
      {{ re.roundId }}</mat-expansion-panel-header
    >
    <div class="w100 col entry" *ngFor="let da of re.reportData">
      @if(da.finalPrompt !== ''){
      <div class="col w100 prompt">
        <div class="row gap-8 space-between w100 tiny">
          <span>LLM: {{ da.llmId }}</span>
          <div class="date row-gap-8">{{ da.date }} | {{ da.time }}</div>
        </div>
        <rr-textarea [value]="da.finalPrompt"></rr-textarea>
        <rr-textarea [value]="da.promptResult"></rr-textarea>
      </div>
      }@else{
      <div class="row gap-8 space-between w100 button">
        {{ da.buttonName }}
        <div class="date row-gap-8 tiny">{{ da.date }} | {{ da.time }}</div>
      </div>

      }
    </div>
  </mat-expansion-panel>
</mat-accordion>
